import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.019 2.283a2.625 2.625 0 1 1 3.712 3.712L7.362 20.364a5.25 5.25 0 0 1-2.213 1.319l-2.685.8a.75.75 0 0 1-.933-.933l.8-2.685a5.25 5.25 0 0 1 1.32-2.214zm2.652 1.06a1.125 1.125 0 0 0-1.591 0l-1.158 1.158 1.591 1.59 1.157-1.157c.44-.439.44-1.151 0-1.59m-2.218 3.81-1.59-1.594L4.71 17.712a3.75 3.75 0 0 0-.942 1.581l-.404 1.356 1.356-.404a3.75 3.75 0 0 0 1.58-.942z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }